import type { Testimonial } from '../pricing-data';

interface TestimonialCardProps {
  testimonial: Testimonial;
}

export function TestimonialCard({ testimonial }: TestimonialCardProps) {
  return (
    <div className="text-center flex flex-col">
      <div className="h-16 flex items-center justify-center">
        <svg className="h-10 w-10 text-gray-300" fill="currentColor" viewBox="0 0 24 24">
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
        </svg>
      </div>
      <blockquote className="text-lg italic text-gray-600 flex-1">
        &quot;{testimonial.quote}&quot;
      </blockquote>
      <div className="mt-4">
        <p className="font-medium text-text-heading">{testimonial.name}</p>
        <p className="text-sm text-gray-500">{testimonial.title}</p>
      </div>
    </div>
  );
}
